import logo from "./logo.svg";
import "./App.css";
import ToDo from "./TodoList/ToDoList";
const App = () => {
  // const { productData, initialise } = useContext(ApiContext);

  return (
    <div className="App">
      <ToDo />
    </div>
  );
};

export default App;
